
import { baseApiUrl } from "../../../env";
import axiosInstance from "../../../Axios/axios";
import axios from "axios";



const login_URL = `${baseApiUrl}/api/v1/Authentication/Login`;
const rememberLogin_URL = `${baseApiUrl}/api/v1/Authentication/RememberLogin`;
const clearRemember_URL = `${baseApiUrl}/api/v1/Authentication/ClearRemember`;
const logout_URL = `${baseApiUrl}/api/v1/Authentication/Logout`;

const loginReq = async (userBody) => {
    let myBody={
  username:"omids",
  updateLogInCount:false,
  password:"passW0rd!",
  rememberMe:true
  }
  return await axios.post(login_URL,userBody,{ withCredentials: true });
};



// const rememberLoginReq = async () => {
//   return axios.post(rememberLogin_URL, null, { withCredentials: true });
// };

// const clearRememberReq = async () => {
//   return axios.post(clearRemember_URL, null, { withCredentials: true });
// };

// const logoutReq = async () => {
//   return axios.get(logout_URL, { withCredentials: true });
// };

// const useGenericApiHook = (
//     queryKey, // کلید کوئری (برای GET) یا null (برای POST/PUT/DELETE)
//     apiFn, // تابع API که باید فراخوانی شود
//     method = 'GET', // نوع عملیات: 'GET', 'POST', 'PUT', 'DELETE'
//     options = {} // آپشن‌های useQuery یا useMutation
// ) => {
//     const queryClient = useQueryClient();

//     if (method === 'GET') {
//         // برای عملیات GET، از useQuery استفاده می‌کنیم
//         return useQuery(queryKey, apiFn, {
//             ...options,
//         });
//     } else {
//         // برای عملیات POST, PUT, DELETE، از useMutation استفاده می‌کنیم
//         const mutationOptions = {
//             onSuccess: (data, variables, context) => {
//                 // اگر queryKey داده شده بود، آن را invalid کنید
//                 if (queryKey) {
//                     queryClient.invalidateQueries(queryKey);
//                 }
//                 // اجرای callback onSuccess کاربر
//                 if (options.onSuccess) {
//                     options.onSuccess(data, variables, context);
//                 }
//             },
//             onError: (error, variables, context) => {
//                 // اجرای callback onError کاربر
//                 if (options.onError) {
//                     options.onError(error, variables, context);
//                 }
//             },
//             ...options,
//         };
//         return useMutation(apiFn, mutationOptions);
//     }
// };

export { loginReq,
  //  rememberLoginReq,
  //   clearRememberReq,
  //    logoutReq
     };
